import axios from 'axios'
import { Message } from 'element-ui';

// axios.defaults.baseURL = process.env.VUE_APP_API_ADDRESS

axios.interceptors.response.use(
    res => {
        return res
    },
    error => {
        if (!error.response) {
            Message({
                message: error.message || '请求失败，请检查网络',
                type: 'error',
            })
        } else {
            Message({
                message: error.message || '系统异常',
                type: 'error',
            })
        }
        return error
    }
)
